/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const QuestionMarkCircleBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 6a4 4 0 0 0-3.97 3.501c-.033.274.194.499.47.499h1c.276 0 .494-.227.562-.495A2.008 2.008 0 0 1 12 8c1.1 0 2 .9 2 2 0 .88-.58 1.324-1.23 1.822-.747.573-1.588 1.217-1.744 2.677-.03.275.198.501.474.501h1c.276 0 .493-.228.553-.497.178-.8.776-1.323 1.388-1.857C15.21 11.973 16 11.283 16 10c0-2.21-1.79-4-4-4Zm-1 11.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1Z" /></svg>);
const QuestionMarkCircle = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={QuestionMarkCircleBase} {...rest} ref={ref} />);
export default QuestionMarkCircle;